import { useContext } from "react";
// import AuthContext from '../global/auth-context';
import { supabase } from "../config/supaconfig_index";
import axios from "axios";

// let baseURL = "https://localhost.com:3323/api/v1";
// let baseURL = "https://green-luck-server.vercel.app/api/v1";
let baseURL =
  "https://greenluckserver-1038087207541.africa-south1.run.app//api/v1";

export async function RequestSignUpOtpService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload.email,
    userName: payload.username,
    // data: 'gi',
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(`${baseURL}/auth/signUp-otp`, requestOptions);
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    // console.log(Data);

    return Data;
  } catch (error) {
    return error;
  }
}

export async function RequestOtpService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload,
    // data: 'gi',
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(`${baseURL}/auth/request-otp`, requestOptions);
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    // console.log(Data);

    return Data;
  } catch (error) {
    return error;
  }
}

export async function SignupService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    userName: payload.username,
    email: payload.email,
    password: payload.password,
    phone: payload.phone,
    country: payload.country,
    countryFlag: payload.countryFlag,

    // data: 'gi',
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(`${baseURL}/auth/signup`, requestOptions);
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function LoginService(payload) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    email: payload.email,
    // email: "wappyfresh@gmail.com",
    password: payload.password,
    // password: "Wappy7",
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(`${baseURL}/auth/login`, requestOptions);
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }

  // fetch(
  //   "https://green-luck-server.vercel.app/api/v1/auth/login",
  //   requestOptions
  // )
  //   .then((response) => response.text())
  //   .then((result) => {
  //     console.log(result);
  //     let Data = JSON.parse(result);
  //     return Data;
  //   })
  //   .catch((error) => console.error(error));
}

export async function LoginWithGoogleWebsiteService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/auth/login-with-google-website`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    // console.log(Data);

    return Data;
  } catch (error) {
    return error;
  }
}

export async function SignupWithGoogleWebsiteService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    userName: payload.username,
    email: payload.email,
    password: payload.password,
    dp: payload.dp,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/auth/signup-with-google-website`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    // console.log(Data);

    return Data;
  } catch (error) {
    return error;
  }
}

// export async function LoginService(payload) {
//   const myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json");

//   const raw = JSON.stringify({
//     email: payload.email,
//     password: payload.password,
//   });

//   const requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: raw,
//     redirect: "follow",
//   };

//   try {
//     const response = await fetch(`${baseURL}/auth/login`, requestOptions);
//     const result_1 = await response.text();
//     console.log(result_1);
//     let Data = JSON.parse(result_1);
//     return Data;
//   } catch (error) {
//     return error;
//   }

//   // fetch("http://localhost:3323/api/v1/auth/login", requestOptions)
//   //   .then((response) => response.text())
//   //   .then((result) => console.log(result))
//   //   .catch((error) => console.error(error));
// }

export async function FetchUserDataService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload,
    // data: 'gi',
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(`${baseURL}/user/fetch-user`, requestOptions);
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchFreeGamesService() {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "Get",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/fetch-free-games`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchFreeCodeService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/fetch-free-code`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function PostFreeGamesService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    code: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/post-free-games`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function DeleteFreeGamesService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    code: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/delete-free-games`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchFreeGamesListService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    code: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/fetch-free-games-list`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchPremiumGamesService() {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "Get",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/fetch-premium-games`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchPremiumCodeService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/fetch-premium-code`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function PostPremiumGamesService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    code: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/post-premium-games`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function DeletePremiumGamesService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    code: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/delete-premium-games`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchPremiumGamesListService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    code: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/games/fetch-premium-games-list`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchPlansService() {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "Get",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/plan/get-all-plans`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchPlanIDService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/plan/get-plan-byID`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchUnitsService() {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "Get",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/unit/get-all-units`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchUnitIDService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/unit/get-unit-byID`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchBookiesService() {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "Get",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/convert/fetch-supported-bookies`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    // console.log(Data);

    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchBookieIDService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    bookieID: payload,
  });

  var requestOptions = {
    method: "Get",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/conver/fetch-bookie-byID`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function ConvertCodeService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload.user,
    from: payload.from,
    to: payload.to,
    code: payload.code,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/convert/convert-code`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function PostSlidersService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    image: payload.image,
    webPage: payload.webPage,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/slider/post-slider`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function DeleteSliderService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/slider/delete-slider`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchSlidersService() {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "Get",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/slider/fetch-sliders`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function UploadImageService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    base64: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/user/upload-image`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    // return Data;

    let path = Data.data.path;

    const UrlResponse = supabase.storage
      .from("public-bucket")
      .getPublicUrl(path, {
        download: true,
      });

    return UrlResponse;
  } catch (error) {
    return error;
  }
}

export async function ChangePasswordService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    oldPassword: payload.oldPassword,
    newPassword: payload.newPassword,
    email: payload.email,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/auth/change-password`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function ResetPasswordService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/auth/reset-password`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function UpdatePasswordService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload.email,
    newPassword: payload.password2,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/auth/update-password`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function AddSliderService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    image: payload.image,
    webPage: payload.webPage,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/slider/post-slider`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function DeleteAccountService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    user: payload,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(`${baseURL}/user/delete-user`, requestOptions);
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function FetchCountriesService() {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "Get",
    headers: myHeaders,

    redirect: "follow",
  };

  try {
    const response = await fetch(
      `https://countriesnow.space/api/v0.1/countries/flag/images`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function UpdateProfileService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload.user,
    phone: payload.phone,
    country: payload.country,
    countryFlag: payload.countryFlag,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/auth/update-profile`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function GetPlanService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload.user,
    planName: payload.planName,
    duration: payload.duration,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(`${baseURL}/plan/get-plan`, requestOptions);
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function BuyUnitService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: payload.user,
    totalUnits: payload.totalUnits,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(`${baseURL}/unit/buy-unit`, requestOptions);
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function GetAllUsersService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "Get",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/admin/get-all-users`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function GetPremiumUsersService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/admin/get-premium-users`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

export async function GetAdminDetailsService(payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseURL}/admin/get-admin-details`,
      requestOptions
    );
    const result_1 = await response.text();
    // console.log(result_1);
    let Data = JSON.parse(result_1);
    return Data;
  } catch (error) {
    return error;
  }
}

// export async function PostFCM(payload) {
//   var myHeaders = new Headers();
//   myHeaders.append('Content-Type', 'application/json');

//   var raw = JSON.stringify({
//     email: payload.user,
//     totalUnits: payload.token,
//   });

//   var requestOptions = {
//     method: 'POST',
//     headers: myHeaders,
//     body: raw,
//     redirect: 'follow',
//   };

//   try {
//     const response = await fetch(`${baseURL}/notification/update-FCM`, requestOptions);
//     const result_1 = await response.text();
//     // console.log(result_1);
//     let Data = JSON.parse(result_1);
//     return Data;
//   } catch (error) {
//     return error;
//   }
// }
